/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { View, Dimensions } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { FeedHeaderView } from '../FeedHeaderView';
import { FeedItemView } from '../FeedItemView';
import type { FeedSectionProps } from './types';

const HORIZONTAL_GAP = 1;
const PADDING_HORIZONTAL = 16;

export const FeedSectionView = ({
  section,
  onSectionHeaderClick,
  onFeedItemClick,
}: FeedSectionProps) => {
  const screenWidth = Dimensions.get('window').width;
  const numberOfItems = section.posts.length;
  const availableWidth = screenWidth - PADDING_HORIZONTAL * 2;
  const totalGap = numberOfItems > 1 ? (numberOfItems - 1) * HORIZONTAL_GAP : 0;
  const itemWidth = (availableWidth - totalGap) / numberOfItems;

  return (
    <View style={styles.section}>
      <FeedHeaderView
        title={section.title}
        sectionId={section.section_id}
        deeplink={section.deeplink}
        location={section.location}
        onPress={onSectionHeaderClick}
      />
      <View style={styles.content}>
        <View style={[styles.row, { width: availableWidth }]}>
          {section.posts.map((post, index) => (
            <FeedItemView
              key={post.post_id}
              post={post}
              sectionId={section.section_id}
              onPress={() => onFeedItemClick?.(post, index)}
              itemWidth={itemWidth}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create(() => ({
  section: {
    width: '100%',
  },
  content: {
    marginBottom: 8,
    paddingHorizontal: PADDING_HORIZONTAL,
  },
  row: {
    flexDirection: 'row' as const,
    gap: HORIZONTAL_GAP,
    borderRadius: 20,
    overflow: 'hidden' as const,
  },
}));
